module.exports = __webpack_public_path__ + "img/12.39824ba2.webp";